import { useState } from "react";
import { ImageUploader } from "./ImageUploader";
import { uploadFile } from "../utils/upload";

interface IImageUploaderContainerProps {
  preview?: string;
  title: string;
  onReady: (ticketId: string) => void;
  onError: (error: string) => void;
  onProgress?: (percent: number) => void;
  onStart?: () => void;
}

export const ImageUploaderContainer: React.FC<IImageUploaderContainerProps> = (props) => {
  const { preview, title, onReady, onError, onProgress, onStart } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [isError, setError] = useState(false);

  const onFileUpload = async (file: File) => {
    onStart && onStart();

    try {
      setLoading(true);
      setError(false);
      const { id } = await uploadFile(
        file,
        (sent: number) => {
          const MULTIPLIFIER = 100;
          const percent = Math.round((sent * MULTIPLIFIER) / file.size);
          onProgress && onProgress(percent);
        }
      );

      onReady(id);
      onProgress && onProgress(0);
    } catch (err) {
      const error = err as Error;
      onError(error.message);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ImageUploader
      preview={preview}
      isError={isError}
      loading={loading}
      title={title}
      onFileUpload={onFileUpload}
    />
  );
};
